<template>
  <div class="funds">
    <v-row>
      <v-col cols="12" sm="6" class="pa-3">
        <h2>Investment Funds</h2>
        <div class="areaTitle">
          <v-select
            v-model="currentManager"
            :style="{ 'max-width': '400px' }"
            :items="managerList"
            item-value="ManagerId"
            item-text="ManagerName"
            label="Manager"
            hide-details="true"
            return-object
            outlined
            dense
          >
          </v-select>
          <v-btn
            color="primary"
            depressed
            :disabled="!showFormButtons || !currentManagerId"
            @click="onButtonClicked('add')"
            class="ml-2"
          >
            <v-icon class="mr-2">mdi-plus</v-icon>
            Add new fund
          </v-btn>
        </div>
        <v-card class="pa-2" outlined tile>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="fundList"
            :items-per-page="-1"
            item-key="PortfolioId"
            single-select
            dense
            @click:row="selectFund"
          >
          </v-data-table>
        </v-card>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="6" class="pa-3">
        <v-alert v-if="!isEditMode && !areManagerAndFundSelected" outlined dense type="info">
          Please select manager and fund.
        </v-alert>
        <div v-else-if="currentManagerId > 0" class="formContainer">
          <span v-if="loading">
            <v-progress-circular
              indeterminate
              :size="20"
              color="blue lighten-5"
              class="mr-2"
            ></v-progress-circular
            >Loading...
          </span>
          <v-form v-else v-model="isFormValid" ref="form" lazy-validation>
            <v-text-field
              outlined
              dense
              label="Fund Name"
              :rules="rules"
              :readonly="!showFormButtons || !isEditMode"
              v-model="currentFund.PortfolioName"
            >
            </v-text-field>
            <v-text-field
              outlined
              dense
              label="Fund Type"
              :rules="rules"
              :readonly="!showFormButtons || !isEditMode"
              v-model="currentFund.PortfolioType"
            >
            </v-text-field>
          </v-form>
          <div v-if="showFormButtons" class="formFooter">
            <div class="btnContainer">
              <v-btn
                v-if="!isEditMode && areManagerAndFundSelected"
                outlined
                color="error"
                @click="onButtonClicked('delete')"
                >Delete</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn v-if="!isEditMode" outlined color="primary" @click="onButtonClicked('edit')">
                Edit
              </v-btn>
              <v-btn v-if="isEditMode" outlined color="primary" @click="onButtonClicked('cancel')">
                Cancel
              </v-btn>
              <v-btn
                v-if="isEditMode"
                depressed
                color="primary"
                @click="onButtonClicked('save')"
                class="ml-4"
                :disabled="!isFormValid"
              >
                Save
              </v-btn>
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn v-if="areManagerAndFundSelected"
          outlined color="primary" @click="goToFundPrices" class="my-4">
            Prices
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <Dialog ref="messageBox"></Dialog>
  </div>
</template>
<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  name: 'Funds',
  components: {
    Dialog,
  },
  data() {
    return {
      readOnly: true,
      fundList: [],
      fundName: '',
      currentFund: {},
      managerList: [],
      managerName: '',
      currentManager: {},
      isEditMode: false,
      count: 0,
      headers: [
        { text: 'Name', value: 'PortfolioName' },
        { text: 'Fund Type', value: 'PortfolioType' },
      ],
      selected: [],
      isFormValid: false,
      rules: [(v) => !!v || 'Required.'],
      loading: false,
    };
  },
  computed: {
    areManagerAndFundSelected() {
      return this.currentManagerId && Object.keys(this.currentFund).length;
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    currentManagerId() {
      if (this.currentManager.ManagerId) return this.currentManager.ManagerId;
      return null;
    },
  },
  watch: {
    currentManagerId() {
      this.getFundList(this.currentManagerId);
    },
    currentManager(){
      this.currentFund = {};
    },
  },
  methods: {
    selectFund(item) {
      this.getFund(item.PortfolioId);
      this.selected = [item];
    },
    createNewFund() {
      return {
        PortfolioId: 0,
        PortfolioName: '',
        PortfolioType: '',
        PortfolioDescription: '',
        BaseCurrency: 'GBP',
        PricingFrequency: '',
        ManagerId: this.currentManager.ManagerId,
        Active: 'Y',
        ManagerName: this.currentManager.ManagerName,
        ActiveInPlan: 0,
      };
    },

    async getFund(fundId) {
      this.loading = true;
      try {
        let response = await this.$api.get('/funds/getFund', { params: { fundId: fundId } });

        if (!response.data) {
          const msg = 'Unable to load fund with id ' + fundId;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.currentFund = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async getFundList(managerId) {
      this.fundList = [];
      this.loading = true;
      try {
        let response = await this.$api.get('/funds/getFundList', {
          params: { managerId: managerId },
        });
        var data = response.data;
        if (response.data) this.fundList = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async getManagerList() {
      try {
        let response = await this.$api.get('/funds/getManagerList');
        var data = response.data;
        this.managerList = data;
      } catch (err) {
        console.error(err);
      }
    },
    async deleteFund() {
      try {
        await this.$refs.messageBox.open(
          'Confirmation',
          'Are you sure you wish to delete this record ?'
        );

        await this.$api.delete('/funds/deleteFund?fundId=' + this.currentFund.PortfolioId);

        this.getFundList(this.currentManagerId);
        this.selected = [];
        this.currentFund = {};
        this.$store.commit('setNotificationMessage', { type: 'success', text: 'Fund is deleted' });
      } catch (error) {
        console.log(error.message);
      }
    },
    async updateFund() {
      this.loading = true;
      try {
        const response = await this.$api.post('/funds/updateFund', this.currentFund);

        this.$store.commit('setNotificationMessage', { type: 'success', text: 'Fund is saved' });

        if (this.currentFund.PortfolioId == 0) this.currentFund.PortfolioId = response.data.Value;

        await this.getFundList(this.currentManagerId);
        await this.getFund(this.currentFund.PortfolioId);
        this.selected = [
          this.fundList.find((fund) => fund.PortfolioId === this.currentFund.PortfolioId),
        ];
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    onButtonClicked(value) {
      if (value == 'cancel') {
        // reload data
        if (this.currentFund.PortfolioId) {
          this.getFund(this.currentFund.PortfolioId);
        } else {
          this.currentFund = {};
        }
        this.readOnly = true;
        this.isEditMode = false;
      } else if (value == 'add') {
        // clear data
        this.isEditMode = true;
        this.currentFund = this.createNewFund();
        this.selected = [];
      } else if (value == 'save') {
        this.isFormValid = this.$refs.form.validate();
        if (this.isFormValid) this.updateFund();
        this.isEditMode = false;
      } else if (value == 'edit') {
        this.isEditMode = true;
      } else if (value == 'delete') {
        this.isEditMode = false;

        this.deleteFund();
      }
    },

    goToFundPrices() {
      this.$router.push({name: 'FundPrices', query: {fundid: this.currentFund.PortfolioId} });
    },
  },

  mounted: function () {
    this.getManagerList();
    this.$root.currentPage = 'Investment';
  },

  destroyed() {
    this.$root.currentPage = null;
  },
};
</script>
<style lang="scss" scoped>
.funds {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 20px;

  .formContainer {
    position: relative;
    height: 100%;

    .formFooter {
      bottom: 0;
      width: 100%;
      margin-top: 5px;

      position: sticky;
      background-color: white;
      padding: 8px 0 0 0;
      border-top: 1px solid rgba(0, 0, 0, 0.12);

      .btnContainer {
        display: flex;
      }
    }
  }

  .areaTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
  }
}
</style>
